<template>
<q-layout view="hHh LpR fFf" container style="height: 100vh" class="bg-neutral-5" :class="{'mobile': !$isDesktop}">
  <page-header>
    <nav-bar v-model:drawer="mobileDrawer"
             :active-section="pageData.section"
    />
  </page-header>

  <sidebar-mobile v-if="!$isDesktop && currentUser" v-model:drawer="mobileDrawer" />
  <sidebar-left v-if="showSidebarLeft" :pageData="pageData" :inner-component="leftSidebarComponent" />
  <sidebar-right v-if="showSidebarRight" v-bind="pageData" />

  <q-page-container id="main">
    <component :is="pageComponent" v-bind="pageData" />
  </q-page-container>

  <page-footer />
</q-layout>
</template>

<script>
import NavBar from './NavBar'
import SidebarLeft from './SidebarLeft'
import SidebarRight from './SidebarRight'
import SidebarMobile from './SidebarMobile'
import PageHeader from './PageHeader'
import PageFooter from './PageFooter'
import MapEdit from '../../pages/map/Edit.vue'
import MapImport from '../../pages/map/Import.vue'
import MapGroupEdit from '../../pages/mapGroup/Edit.vue'
import MapGroupIndex from '../../pages/mapGroup/Index.vue'

export default {
  props: {
    pageComponent: {
      type: String,
      required: true,
    },
    leftSidebarComponent: {
      type: String,
    },
    pageData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  components: {
    NavBar,
    PageHeader,
    PageFooter,
    SidebarLeft,
    SidebarRight,
    SidebarMobile,
  },
  data () {
    return {
      mobileDrawer: false,
    }
  },
  computed: {
    showSidebarLeft () {
      const pages = [
        'CategoryCreate',
        'CategoryEdit',
        'CategoryIndex',
        'CategoryShow',
        'CustomRuleCreate',
        'CustomRuleEdit',
        'FlexibleRuleEdit',
        'MapEdit',
        'MapImport',
        'MapGroupEdit',
        'MapGroupIndex',
        'ObjectCreate',
        'ObjectEdit',
        'ObjectIndex',
        'ObjectGroupCreate',
        'ObjectGroupEdit',
        'ObjectGroupIndex',
        'ObjectShow',
        'PhaseCreate',
        'PhaseEdit',
        'PhaseIndex',
        'ProjectCategoryEdit',
        'ProjectMapEdit',
        'ProjectShow',
        'ProjectObjectEdit',
        'ProjectObjectShow',
        'ProjectRuleIndex',
        'ProjectRuleShow',
        "ProjectImportIndex",
        "ProjectImportShow",
        'RoleCreate',
        'RoleEdit',
        'RoleIndex',
        'RuleCreate',
        'RuleEdit',
        'RuleShow',
        'RuleIndex',
        'SubcategoryCreate',
        'SubcategoryEdit',
        'ThemeCreate',
        'ThemeEdit',
        'ThemeIndex',
        'UserCreate',
        'UserEdit',
        'UserIndex',
      ]
      return this.$isDesktop && pages.includes(pageComponent)
    },
    showSidebarRight () {
      const pages = ['ProjectShow', 'RuleShow', 'ProjectRuleIndex', 'ProjectRuleShow', 'ProjectObjectShow']
      return this.$isDesktop && pages.includes(pageComponent)
    },
  },
}
</script>
